import React from "react";

import { ClinicalEvaluationStep } from "./components/stepper";
import { Container } from "@mui/material";
import { ClinicalEvaluationProvider } from "shared/providers/ClinicalEvaluation";

const ClinicalEvaluation: React.FC = () => {
  return (
    <ClinicalEvaluationProvider>
      <Container maxWidth="xl">
        <ClinicalEvaluationStep />
      </Container>
    </ClinicalEvaluationProvider>
  );
};

export { ClinicalEvaluation };
